import moment from "moment";

interface DurationTime {
  [key: string]: number;
}

export const formatDuration = (end: number, start: number) => {
  const millis = Number(end) - Number(start);
  if (millis === 0) return "0 sec";
  const time: DurationTime = {
    yr: 31536000,
    day: 86400,
    hr: 3600,
    min: 60,
    sec: 1,
  };
  const res = [];
  let seconds = millis * 0.001;

  for (let key in time) {
    if (seconds >= time[key]) {
      let val: any = Math.floor(seconds / time[key]);
      res.push((val += val > 1 ? " " + key + "s" : " " + key));
      seconds = seconds % time[key];
    }
  }

  return res.length > 1
    ? res
        .join(" ")
        .replace(/,([^,]*)$/, "$1")
        .replace(",", "")
    : res[0];
};

export const formatDateToString = (date: any) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var mins = date.getMinutes();
  var secs = date.getSeconds();

  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  hours = hours < 10 ? "0" + hours : hours;
  mins = mins < 10 ? "0" + mins : mins;
  secs = secs < 10 ? "0" + secs : secs;

  return year + "-" + month + "-" + day + " " + hours + ":" + mins + ":" + secs;
};

export const formatDateToString2 = (time: any) => {
  var date: any = new Date(time);
  if (date == "Invalid Date") {
    return "";
  }

  var year = date.getFullYear();
  var day: any = date.getDate();
  var monthString = date.toLocaleString("default", { month: "short" });

  var hours = date.getHours();
  var formattedHours: any = hours % 12 || 12; // If hours is 0, use 12
  const period = hours < 12 ? "AM" : "PM";
  var mins: any = date.getMinutes();

  day = day < 10 ? "0" + day : day;
  formattedHours = hours < 10 ? "0" + hours : hours;
  mins = mins < 10 ? "0" + mins : mins;

  return `${monthString} ${day}, ${year} ${formattedHours}:${mins} ${period}`;
};

export const getDurationFromSec = (secs: any) => {
  if (secs < 60) {
    return secs + " sec(s)";
  }
  let remainSec = secs % 60;
  let mins = parseInt(((secs - remainSec) / 60).toString());
  if (mins < 60) {
    return mins + " min(s)" + (remainSec ? " " + remainSec + " sec(s)" : "");
  }
  let remainMin = mins % 60;
  let hours = parseInt(((mins - remainMin) / 60).toString());
  return hours + " hour(s)" + (remainMin ? " " + remainMin + " min(s)" : "");
};

export const getDatefromLong = (time: string) => {
  const date = new Date(time);

  // Add 14 days
  date.setDate(date.getDate() + 14);

  // Get the month, day, and year
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  // Return in mm/dd/yyyy format
  return `${month}/${day}/${year}`;
};

export const isMoreThan14Days = (long: any) => {
  const currentDate: any = new Date().getTime();

  // Get the difference in time (in milliseconds)
  const timeDifference = currentDate - long;

  // Convert milliseconds to days
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  // Return true if the difference is greater than 14 days
  return daysDifference > 14;
};

export const disableYearsAgoDate = (date: any, num = 10) => {
  var currentDate = new Date();
  var tenYearsAgo = new Date(currentDate);
  tenYearsAgo.setFullYear(currentDate.getFullYear() - num);
  // return date < tenYearsAgo;
  return date < new Date("2023-01-01");
};

export const disableDatesBetween = (date: any, startDate: any, num = 10) => {
  var currentDate = new Date();
  var tenYearsAgo = new Date(currentDate);
  tenYearsAgo.setFullYear(currentDate.getFullYear() - num);
  return date < new Date("2023-01-01") || date < startDate;
};

export const disableYears = (date: any, num = 10) => {
  var curDate = new Date(date);
  var currentDate = new Date();
  var tenYearsAgo = currentDate.getFullYear() - 10;
  var curYear = curDate.getFullYear();
  // return curYear < tenYearsAgo;
  return curYear < 2023;
};

export const disableYearsBetween = (date: any, startDate: any, num = 10) => {
  var curDate = new Date(date);
  var currentDate = new Date();
  var tenYearsAgo = currentDate.getFullYear() - 10;
  var curYear = curDate.getFullYear();

  var curStartDate = new Date(startDate);
  var curStartYear = curStartDate.getFullYear();
  return curYear < 2023 || curYear < curStartYear;
};

export const toHumanReadableFormat = (time: any) => moment(time).format("MMM D, YYYY hh:mm A");

export const toHumanReadableFormatDateOnly = (time: any) => moment(time).format("MMM D, YYYY");

export const isValidTimestamp = (number: number) => {
  // Check if it's a finite number
  if (typeof number !== "number" || !Number.isFinite(number)) return false;
  // Epoch values we format are at least 10 digits (ms or seconds since ~2001).
  if (Math.abs(number) < 1_000_000_000) return false;

  // Create a Date object
  const date = new Date(number);

  // Check if the Date object is valid
  return date.getTime() === number;
};

export const epochToDate = (epochTimestamp: any) => {
  const date = new Date(epochTimestamp); // Convert to milliseconds
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");

  return `${month}/${day}/${year}`;
};
